function pricingOptionsBookmarkOpen(id) {
    $('[id^=type]').hide();
    id.show();
}

function remotePricingOptionsBookmarks() {
    const pricingOptionsInputChecked = $('[data-facility-box-move]:checked').attr('value');
    if (pricingOptionsInputChecked === 1) { pricingOptionsBookmarkOpen($('#type-sell')); } else if (pricingOptionsInputChecked === 2) { pricingOptionsBookmarkOpen($('#type-rent')); }
}

$(document).ready(() => {
    remotePricingOptionsBookmarks();
});
